import React, { useState, useEffect } from 'react';
import DropdownList from '../../components/DropdownList/DropdownList';
import FileUploader from '../../components/FileUploader/FileUploader';
import TextArea from '../../components/TextArea/TextArea';
import RegisterHeader from '../../components/RegisterHeader/RegisterHeader';
import RegisterFooter from '../../components/RegisterFooter/RegisterFooter';
import Popup from '../../components/PopUp/PopUp';
import './ProducerRegistration.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAllChannels, setAllGeners, setAllLanguages, setAllCountries, setProvience, setSelectedData, removeSelectedData, removeAllData, clearAllChannels, clearAllCountries } from './ProducerRegistrationSlice';
import { fetchProvienceByCountry, fetchAllCountries, fetchEmail, fetchByfilter } from '../../services/GenericAPI';
import { useNavigate } from 'react-router-dom';
import TermsConditions from '../../components/TermsConditions/TermsConditions';
import TitledCheckedDropDown from '../../components/TitledCheckedDropDown/TitledCheckedDropDown';
import { registration } from '../../services/Registration';
import { validatePhoneNumber, validateName, validateWebsite, validateSocialMediaLinks } from '../../util/util';
import { removeAllCheck } from '../../components/TermsConditions/TermsConditionsSlice';
import ProgressLoader from '../../components/ProgressLoader/ProgressLoader';
import { useLanguage } from '../../context/Languagecontext';
import { Globals as OldGlobals} from '../../global/Globals';

import FallBackLabel from '../../global/Globals_Eng.json';
const ProducerRegistration = () => {
    const { Globals ,languages, setLanguages } = useLanguage();
    let countriesList = [];
    const [socialLinks, setSocialLinks] = useState(['']);
    const [title, setTitle] = useState('');
    const [name, setName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [address, setAddress] = useState('');
    const [provience, setProvience] = useState('');
    const [country, setCountry] = useState('');
    const [website, setWebSite] = useState('');
    const [language, setLanguage] = useState('');
    const [genre, setGenre] = useState([{}]);
    const [channel, setChannel] = useState('');
    const [email, setEmail] = useState('');
    const [isEmailInvalid, setIsEmailInvalid] = useState(false);
    const [isPhoneInValid, setIsPhoneInValid] = useState(false);
    const [isEmailExist, setIsEmailExist] = useState(false);
    const [countSelection, setCountSelection] = useState('');
    const [provincesList, setProvincesList] = useState([]);
    const [provicesDetails, setProvicesDetails] = useState([]);
    const [isRegCanceled, setRegCancel] = useState(false);
    const [isRegSuccess, setRegSuccess] = useState(false);
    const [isRegFailed, setRegFailure] = useState(false);
    const [borderColor, setBorderColor] = useState('');
    const [isNameInvalid, seIsNameInvalid] = useState(false);
    const [isWebSiteInvalid, setIsWebSiteInvalid] = useState(false);
    const [isTitleNotSelected, setTitleNotSelected] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [loading,setLoading] =useState(false);
    const [isSocialMediaInvalid, setIsSocialMediaInvalid] = useState(
        new Array(socialLinks.length).fill(false)
    );
    const [file, setFile]=useState(null);
    const [isLoading, setIsLoading]=useState(false);
    const allChannelsData = useSelector(state => state.producerRegistration.allChannels);
    const allLanguagesData = useSelector(state => state.producerRegistration.allLanguages);
    const allGenersData = useSelector(state => state.producerRegistration.allGeners);
    const allCountriesDetails = useSelector(state => state.producerRegistration.allCountries);
    const allCountriesData = useSelector(state => state.producerRegistration.allCountries.map(ele => ele.countryName));
    const isAgreementChecked = useSelector(state => state.termsConditions.isAgreementChecked);
    const isPolicyChecked = useSelector(state => state.termsConditions.isPolicyChecked);
    const isConfidentialInfoChecked = useSelector(state => state.termsConditions.isConfidentialInfoChecked);
    // const [areTermsAgreed, setTermsAgreed] = useState(isPolicyChecked);
    const countries = useSelector(state => state.producerRegistration.allCountries);
    const selectedLanguagesList = useSelector(state => state.producerRegistration.selectedLanguages);
    const selectedGenresList = useSelector(state => state.producerRegistration.selectedGenres);
    const selectedChannelsList = useSelector(state => state.producerRegistration.selectedChannels);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const addSocialLink = () => {
        setSocialLinks([...socialLinks, '']);
        setIsSocialMediaInvalid([...isSocialMediaInvalid, false]);
    };

    const removeSocialLink = (index) => {
        const updatedLinks = socialLinks.filter((_, i) => i !== index);
        setSocialLinks(updatedLinks);
        // Clear invalid state for the removed input
        const updatedInvalidState = isSocialMediaInvalid.filter((_, i) => i !== index);
        setIsSocialMediaInvalid(updatedInvalidState);

        // You can also reset the error state if needed when no social link exists
        if (updatedLinks.length === 0) {
            setIsSocialMediaInvalid([false]);
        }
    };

    const [_navigated, setNavigated] = useState(false);

  useEffect(() => {
    const handlePopstate = (event) => {
      if (_navigated) {
        setNavigated(false);
        return;
      }

      setRegCancel(true);
    };

    window.addEventListener('popstate', handlePopstate);

    // Initial pushState to ensure we catch the first navigation attempt
    window.history.pushState(null, null, window.location.href);

    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, [_navigated]);

    useEffect(() => {
        if (allLanguagesData || allLanguagesData.length === 0) {
            fetchByfilter("Languages").then((response) => {
                dispatch(setAllLanguages({ allLanguages: response.data.content["Languages"] }));
            })
        }
        if (allGenersData || allGenersData.length === 0) {
            fetchByfilter("Genres").then((response) => {
                dispatch(setAllGeners({ allGeners: response.data.content["Genres"] }));
            })
        }
        if (allChannelsData.length === 0) {
            fetchByfilter("Channels").then((response) => {
                dispatch(setAllChannels({ allChannels: response.data.content["Channels"] }));
            })
        }
        if (allCountriesData.length === 0) {
            fetchAllCountries().then((response) => {
                dispatch(setAllCountries({ allCountries: response.data.content }));
                countriesList = response.data.content.map(country => country.countryName)
            }).catch((error) => {
                console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
            });
        }
    }, []);

    const handleTitleSelection = (event) => {
        setTitleNotSelected(false);
        setTitle(event);
        setBorderColor('#0B0C0C')
    }

    const handleUserName = (event) => {
        checkTitle();
        seIsNameInvalid(false);
        setName(event.target.value);
        //checkName();
        //setBorderColor('#0B0C0C')
    }

    const handleEmail = (event) => {
        setIsEmailInvalid(false);
        setIsEmailExist(false);
        setEmail(event.target.value);
        setBorderColor('#0B0C0C')
    }

    const handleAddress = (event) => {
        setAddress(event);
        setBorderColor('#0B0C0C')
    }

    const handlePhoneNumber = (event) => {
        setIsPhoneInValid(false);
        const phNumber = event.target.value
        const res = validatePhoneNumber(phNumber);
        setPhoneNumber(phNumber); setIsPhoneInValid(!res);
        setBorderColor('#0B0C0C')
    }

    const handleProvience = (event) => {
        const provienceID = provicesDetails.find(item => item.provinceName === event).provinceId;
        setProvience(provienceID);
        setBorderColor('#0B0C0C')
    }

    const handleCountry = (event) => {
        const countryId = allCountriesDetails.find(item => item.countryName === event).countryId;
        setCountry(countryId);
        setBorderColor('#0B0C0C')

        fetchProvienceByCountry(countries, event).then((response) => {
            setProvicesDetails(response.data.content);
            setProvincesList(response.data.content.map(prov => prov.provinceName));
            dispatch(setProvience({ provience: response.content.map(prov => prov.provinceName) }))
        }).catch((error) => {
            console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
        });
    }

    const handleWebSite = (event) => {
            setWebSite(event.target.value);
    }

    const handleSocialMedia = (index, event) => {
        const newSocialLinks = [...socialLinks];
        newSocialLinks[index] = event.target.value;
        setSocialLinks(newSocialLinks);
    };
    const processUserRegsitartion = () => {
       // dispatch(removeAllCheck());
        const requestObj = {
            logofile:file,
            producerType: Globals.SIGNUP.TYPE.INDIVIDUAL,
            title:title,
            name: name,
            email: email,
            businessAddress: address,
            companyContactNumber: phoneNumber,
            language: selectedLanguagesList,
            genre: selectedGenresList,
            channels: selectedChannelsList,
            website: website,
            socialMediaLinks: socialLinks.toString(),
            country: country ? country : 0,
            provience: provience ? provience : 0,
            title:title,
            isConsent: isConfidentialInfoChecked === true ? true : false
        }
        setLoading(true)
        registration(requestObj).then((response) => {
            setLoading(false)
            if(response.data.status!=="OK"){setRegFailure(true);}
            else if (response.data.content) {
                setRegSuccess(true);
            }
            else {
                setRegFailure(true);
            }
        }).catch((error) => {
            setLoading(false)
            console.error("Registraion Failed", error);
            setRegFailure(true);
            setIsLoading(false);
        })
    }

    const cancelRegistration = () => {
        setRegCancel(true);
    }

    const navigateBackToSignUp = () => { navigate(Globals.NAVPATH.SIGNUP); }
    const navigateToLogin = () => { navigate(Globals.NAVPATH.ROOT); }
    const handleAggreement = (areBothChecked) => { }

    const checkForEmail = () => {
        setIsTouched(true);
        setIsEmailInvalid(false);
        setIsEmailExist(false);
        if (email.length === 0) {
            setIsEmailInvalid(false);
            setIsEmailExist(false);
        }
        else {
            const regex = OldGlobals.REGEX.EMAIL_REGEX;
            const isValid = regex.test(email);
            if (isValid) {
                fetchEmail(email).then((response) => {
                    response.data.exists ? setIsEmailExist(true) : setIsEmailExist(false);
                }).catch((error) => { console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error) })
            }
            else {
                setIsEmailInvalid(!isValid);
            }
        }
    }

    const checkName = () => {
       // const isValid = validateName(name);
        name.length>0 ? seIsNameInvalid(false) : seIsNameInvalid(true);
    }

    const checkTitle = () => {
        title.trim() === "" ? setTitleNotSelected(true) : setTitleNotSelected(false);
    }

    const handleSelectAllGenres = (e) => {
        setBorderColor('#0B0C0C')
        e ? allGenersData.map((item) => {
            dispatch(setSelectedData({ option: "Genres", element: item.id }))
        }) : dispatch(removeAllData({ option: "Genres" }))
    }
    const handleSelectedGenreValues = (genreId) => {
        setBorderColor('#0B0C0C')
        selectedGenresList.find(item => item.genreId === genreId) ?
            dispatch(removeSelectedData({ option: "Genres", element: genreId })) :
            dispatch(setSelectedData({ option: "Genres", element: genreId }))
    }

    const handleSelectedLanguageValues = (langId) => {
        setBorderColor('#0B0C0C')
        selectedLanguagesList.find(item => item.languageId === langId) ?
            dispatch(removeSelectedData({ option: "Languages", element: langId })) :
            dispatch(setSelectedData({ option: "Languages", element: langId }))
    }

    const handleSelectAllLanguages = (e) => {
        setBorderColor('#0B0C0C')
        e ? allLanguagesData.map((item) => {
            dispatch(setSelectedData({ option: "Languages", element: item.id }))
        }) : dispatch(removeAllData({ option: "Languages" }))
    }

    const handleSelectedChannelValues = (channelId) => {
        setBorderColor('#0B0C0C')
        selectedChannelsList.find(item => item.channelId === channelId) ?
            dispatch(removeSelectedData({ option: "Channels", element: channelId })) :
            dispatch(setSelectedData({ option: "Channels", element: channelId }))
    }

    const handleSelectAllChannels = (e) => {
        setBorderColor('#0B0C0C')
        e ? allChannelsData.map((item) => {
            dispatch(setSelectedData({ option: "Channels", element: item.id }))
        }) : dispatch(removeAllData({ option: "Channels" }))
    }

    const clearCheckedList = () => {
        dispatch(removeAllData({ option: "Channels" }));
        dispatch(removeAllData({ option: "Languages" }));
        dispatch(removeAllData({ option: "Genres" }));
        dispatch(removeAllCheck());
        dispatch(clearAllChannels());
        dispatch(clearAllCountries());
    }

    const resetCheckBox=()=>{
        dispatch(removeAllCheck());
    }

    const checkForEmptyNumber = () => {
        if(phoneNumber.trim() === "" ){ 
            setIsPhoneInValid(true) 
        }
        else{
            const res = validatePhoneNumber(phoneNumber);
            setIsPhoneInValid(!res);
        }
    }

    const handleFileInput=(file)=>{
        setFile(file);
    }

    const handleChange = (e) => {
        const selectedLang = e.target.value;
        localStorage.setItem("lang", selectedLang);
        setLanguages(selectedLang); // trigger re-render
        window.dispatchEvent(new Event("storage")); // ensure same-tab update
      };

    const isFormValid =
        title.trim() !== '' &&
        name.trim() !== '' &&
        email.trim() !== '' &&
        phoneNumber.trim() !== '' &&
        isPolicyChecked === true &&
        isAgreementChecked===true &&
        isConfidentialInfoChecked===true &&
        !isEmailInvalid &&
        !isEmailExist &&
        !isPhoneInValid &&
        !isNameInvalid &&
        !isWebSiteInvalid &&
        isSocialMediaInvalid.every(value => value === false) &&
        !isTitleNotSelected &&
        !isNameInvalid &&
        !isWebSiteInvalid;

    return (
        <div id="register-container" className="register-container">
            {/* <LanguageSelector /> */}
            {/* <div>
             <select value={languages} onChange={handleChange}>
      <option value="en">English</option>
      <option value="afk">Afrikaans</option>
      <option value="port">Portuguese</option>
    </select>
    </div> */}
            <RegisterHeader onCancelRegister={cancelRegistration} title={Globals.SIGNUP.INDIVIDUAL} />
            <div id="register-form" className="register-form">
                <div id="register-form-content" className="register-form-content">
                    <h3 id="basic-info" className="basic-info">{Globals.SIGNUP.BASIC_INFO}</h3>
                    <div id="row-content" className="row-1-content">
                        <div id="title-holder">
                            <label id="user-title" className="user-title">{Globals.SIGNUP.TITLE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span tabIndex={1} onBlur={checkTitle}><DropdownList options={Globals.SIGNUP.TITLES_LIST} placeHolderValue={Globals.SIGNUP.TITLES_INP_PLACEHOLDER} onSelect={handleTitleSelection} selectClass={title && "hightlight"}  /></span>
                            {isTitleNotSelected && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.UNSELECTED_TITLE}</label></div>}
                        </div>
                        <div id="name-holder">
                            <label id="name">{Globals.SIGNUP.NAME}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="text" id="name-inp" defaultValue={name} className={`name-inp ${name && name.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.NAME_INP_PLACEHOLDER} onChange={handleUserName} tabIndex={2} onBlur={checkName} maxLength={30} autoComplete='off'></input>{/**onBlur={checkName} */}
                            {isNameInvalid && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{name.trim().length === 0 ? Globals.ERROR_MESSAGES.EMPTY_NAME : Globals.ERROR_MESSAGES.INVALID_NAME}</label></div>}
                        </div>
                        <div id="email-holder">
                            <label id="email">{Globals.SIGNUP.EMAIL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="email" id="reg-email-inp" className={`reg-email-inp ${email && email.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.EMAIL_INP_PLACEHOLDER} onChange={handleEmail} onBlur={checkForEmail} tabIndex={3} autoComplete='off'></input>
                            {isTouched && (email.length === 0 || isEmailInvalid || isEmailExist) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>
                                {email.length === 0 ? Globals.ERROR_MESSAGES.REG_EMPTY_EMAIL :
                                    isEmailInvalid ? Globals.ERROR_MESSAGES.REG_INVALID_EMAIL :
                                        Globals.ERROR_MESSAGES.EMAIL_EXIST}
                            </label></div>}
                        </div>
                        <div id="phone-number-holder">
                            <label id="phone-number">{Globals.SIGNUP.PHONE_NUMBER}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="tel" pattern="[0-9+]+" id="phone-number-inp" className={`phone-number-inp ${phoneNumber && phoneNumber.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.PHONE_NUMBER_INP_PLACEHOLDER} onChange={handlePhoneNumber} onBlur={checkForEmptyNumber} tabIndex={4} maxLength={phoneNumber.charAt(0)=='+'?16:15} autoComplete='off'></input>
                            {isPhoneInValid && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="phone number error" /><label className='invalidCredential'>{phoneNumber.length > 0 ? Globals.ERROR_MESSAGES.INVALID_PHONE_NUMBER : Globals.ERROR_MESSAGES.EMPTY_PHONE_NUMBER}</label></div>}
                        </div>
                    </div>
                    <div id="row-content" className="row-1-content">
                        <div id="logo-pic-holder">
                            <label id="logo-pic" className="logo-pic">{Globals.SIGNUP.LOGO_PIC}</label>
                            <span tabIndex={5}><FileUploader onFileUpload={(file)=>handleFileInput(file)} supportedFileType="ImagesOnly" isFromRegPage={true} isLogoHolder={true}/></span>
                        </div>
                        <div id="physical-address-holder">
                            <label id="physical-address" className="physical-address">{Globals.SIGNUP.PHYSICAL_ADDRESS}</label>
                            <span tabIndex={6}><TextArea placeHolder={Globals.SIGNUP.ADDRESS_PLACEHOLDER} textAreaInput={handleAddress} className={address && address.length > 0 ? "hightlight" : ""} /></span>
                        </div>
                        <div id="country-holder">
                            <label id="country" className="country">{Globals.SIGNUP.COUNTRY}</label>
                            <span tabIndex={7}><DropdownList options={allCountriesData} placeHolderValue={Globals.SIGNUP.COUNTRY_PLACEHOLDER} onSelect={handleCountry} selectClass={country && "hightlight"} /></span>
                        </div>
                        <div id="provience-holder">
                            <label id="provience" className="provience">{Globals.SIGNUP.PROVIENCE}</label>
                            <span tabIndex={8}><DropdownList options={provincesList} placeHolderValue={Globals.SIGNUP.PROVIENCE_PLACEHOLDER} onSelect={handleProvience} selectClass={provience && "hightlight"} valueToReset={country} /></span>
                        </div>
                    </div>
                    <div id='website-holder'>
                        <label id="website" className="website">{Globals.SIGNUP.WEBSITE}</label>
                        <input type="url" id="website-inp" className={`website-inp ${website && website.trim()!=="" ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.WEBSITE_PLACEHOLDER} onChange={handleWebSite} tabIndex={9} autoComplete='off'></input>
                        {/* {isWebSiteInvalid && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.INVALID_WEBSITE}</label></div>} */}
                    </div>
                    <div id="row-content" className="row-1-content">
                        <div id="social-media-holder">
                            <label id="social-media" className="social-media">{Globals.SIGNUP.SOCIAL_MEDIA}</label>
                            {socialLinks.map((link, index) => (
                                <div className="reg-social-media-default-inp" style={{ display: 'flex' }}>
                                    <div id="social-media-section" className="social-media-section">
                                        <input
                                            key={index}
                                            value={link}
                                            type="url"
                                            id="reg-social-media-inp"
                                            className={`reg-social-media-inp ${socialLinks[index].length > 0 ? "hightlight" : ""}`}
                                            placeholder={Globals.SIGNUP.SOCIAL_MEDIA_PLACEHOLDER}
                                            onChange={(event) => handleSocialMedia(index, event)}
                                        />
                                        {/* {isSocialMediaInvalid[index] === true && (
                                            <div>
                                                <img
                                                    id="login-error"
                                                    className="login-error"
                                                    src={Globals.IMG.ERROR}
                                                    alt="password error"
                                                />
                                                <label className="invalidCredential">{Globals.ERROR_MESSAGES.INVALID_SOCIAL_MEDIA_LINKS}</label>
                                            </div>
                                        )} */}
                                    </div>
                                    {index > 0 && (
                                        <button
                                            type="button"
                                            className="remove-social-link"
                                            onClick={() => removeSocialLink(index)}
                                        />
                                    )}
                                </div>
                            ))}
                            {socialLinks.length < 3 ? (
                                <button
                                    type="button"
                                    id="reg-add-social-link"
                                    className="reg-add-social-link"
                                    onClick={addSocialLink}
                                >
                                    {Globals.SIGNUP.ADD_MORE_LINKS}
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    id="reg-add-social-link-disabled"
                                    className="reg-add-social-link-disabled"
                                    disabled={true}
                                >
                                    {Globals.SIGNUP.ADD_MORE_LINKS}
                                </button>
                            )}
                        </div>
                    </div>
                    <div id="row-content" className="row-1-content">
                        <div id="language-holder">
                            <label id="language" className="language">{Globals.SIGNUP.LANGUAGE}</label>
                            <span tabIndex={10}><TitledCheckedDropDown
                                title={Globals.SIGNUP.LANGUAGE_PLACEHOLDER}
                                options={allLanguagesData}
                                onSelectAll={handleSelectAllLanguages}
                                onSelect={handleSelectedLanguageValues}
                                selectedValues={selectedLanguagesList}
                                selectClass={selectedLanguagesList.length > 0 ? "hightlight" : ""}
                            /></span>
                        </div>
                        <div id="genre-holder">
                            <label id="genre" className="genre">{Globals.SIGNUP.GENRE}</label>
                            <span tabIndex={11}><TitledCheckedDropDown
                                title={Globals.SIGNUP.GENRE_PLACEHOLDER}
                                options={allGenersData}
                                onSelectAll={handleSelectAllGenres}
                                onSelect={handleSelectedGenreValues}
                                selectedValues={selectedGenresList}
                                selectClass={selectedGenresList.length > 0 ? "hightlight" : ""}
                            /></span>
                        </div>
                        <div id="channels-holder">
                            <label id="channels" className="channels">{Globals.SIGNUP.CHANNELS}</label>
                            <span tabIndex={12}><TitledCheckedDropDown
                                title={Globals.SIGNUP.CHANNELS_PLACEHOLDER}
                                options={allChannelsData}
                                onSelectAll={handleSelectAllChannels}
                                onSelect={handleSelectedChannelValues}
                                selectedValues={selectedChannelsList}
                                selectClass={selectedChannelsList.length > 0 ? "hightlight" : ""}
                            /></span>
                        </div>
                    </div>
                    <div className="seperator"></div>
                    <span><TermsConditions checkForAgreement={handleAggreement} tabIndex1={13}/></span>
                </div>

            </div>
            <div>
            </div>
            <div>
                <span><RegisterFooter onCancelRegister={cancelRegistration} isButtonEnabled={isFormValid} onSubmit={processUserRegsitartion} tabIndex1={14} tabIndex2={15}/></span>
            </div>
            <div>
                {isRegCanceled && <div className='popup-bg'><Popup title={Globals.SIGNUP.POPUP.CANCEL.TITLE}
                    text={Globals.SIGNUP.POPUP.CANCEL.MESSAGE}
                    negativeAction={navigateBackToSignUp}
                    negativeActionText={Globals.SIGNUP.POPUP.CANCEL.BUTTON_TEXT}
                    popupType={"abort"}
                    onClose={() => setRegCancel(false)}
                    clearData={clearCheckedList}
                    resetPolicy={resetCheckBox}
                /></div>}
                {isRegFailed && <div className='popup-bg'><Popup title={Globals.SIGNUP.POPUP.FAILURE.TITLE}
                    text={Globals.SIGNUP.POPUP.FAILURE.MESSAGE}
                    normalAction={processUserRegsitartion}
                    normalActionText={Globals.SIGNUP.POPUP.FAILURE.BUTTON_TEXT}
                    popupType={"failed"}
                    onClose={() => setRegFailure(false)}
                   // clearData={clearCheckedList}
                   // resetPolicy={resetCheckBox}
                /></div>}
                {isRegSuccess && <div className='popup-bg'><Popup title={Globals.SIGNUP.POPUP.SUCCESS.TITLE}
                    text={''}
                    normalAction={navigateToLogin}
                    normalActionText={Globals.SIGNUP.POPUP.SUCCESS.BUTTON_TEXT}
                    popupType={"success"}
                    onClose={() => setRegSuccess(false)}
                    clearData={clearCheckedList}
                    resetPolicy={resetCheckBox}
                /></div>}
                {
                    isLoading&&<ProgressLoader height={50} width={50} component={"Reg"}/>
                }
            </div>
            {loading && <ProgressLoader height={50} width={50} component={"unsolicated-edit"}/>}
        </div>
    )
}
export default ProducerRegistration;